export default __webpack_public_path__ + "static/media/service04.bdb862a0.svg";